var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ma-modal-camera-flow",
    {
      ref: "modalPhotoclaimForm",
      attrs: { type: "full" },
      on: { "modal:close": _vm.resetForms },
    },
    [
      _c(
        "template",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading",
            },
          ],
          slot: "modalContent",
        },
        [
          _c(
            "div",
            { staticClass: "modal__main view" },
            [
              _c("ma-notifications"),
              _c("ma-camera-with-steps", {
                staticClass: "photoclaim-camera",
                attrs: {
                  title: _vm.literalDamagePart,
                  groups: _vm.groups,
                  steps: _vm.photosPerDamage,
                },
                on: {
                  photosArray: _vm.handlePhotos,
                  photo: _vm.handleCameraPhoto,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.loading
        ? _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main has-modal" },
              [_c("maSpinner", { staticClass: "spinner" })],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }